import { render, staticRenderFns } from "./NewsLoadFooter.vue?vue&type=template&id=db006390&scoped=true"
import script from "./NewsLoadFooter.vue?vue&type=script&lang=js"
export * from "./NewsLoadFooter.vue?vue&type=script&lang=js"
import style0 from "./NewsLoadFooter.vue?vue&type=style&index=0&id=db006390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db006390",
  null
  
)

export default component.exports